import { render, staticRenderFns } from "./bindCoach.vue?vue&type=template&id=5c4d5344&scoped=true&"
import script from "./bindCoach.vue?vue&type=script&lang=js&"
export * from "./bindCoach.vue?vue&type=script&lang=js&"
import style0 from "./bindCoach.vue?vue&type=style&index=0&id=5c4d5344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d5344",
  null
  
)

export default component.exports